import { render, staticRenderFns } from "./ArchivedPlanHome.vue?vue&type=template&id=218dfb80"
import script from "./ArchivedPlanHome.vue?vue&type=script&lang=js"
export * from "./ArchivedPlanHome.vue?vue&type=script&lang=js"
import style0 from "./ArchivedPlanHome.vue?vue&type=style&index=0&id=218dfb80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports